<template>
  <div>
    <Navbar />
    <div class="container">
      <div class="img">
        <img src="@/assets/images/pages/personal_data.svg">
      </div>
      <div class="signup-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3>Personal Details</h3>
          <p>The more we know, the more we undertand you.</p>
          <div class="input-div mt-2">
            <div>
              <vs-input 
                label-placeholder="EMAIL" 
                disabled="true" 
                v-model="email"
                class="email w-full mt-6"
                :success="true" 
                success-text="This email has been verified."
                val-icon-pack="feather"
                val-icon-success="icon-user-check"
                size="large"
                />
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
               <vs-input
                v-validate="'max:255|alpha_spaces|required'"
                data-vv-validate-on="blur"
                name="first name"
                label-placeholder="FIRST NAME"
                v-model="first_name"
                class="w-full mt-8"
                icon-pack="feather" 
                icon="icon-user"
                icon-no-border
                size="large" />
                <span class="text-danger text-sm float-left">{{ errors.first('first name') }}</span>
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
               <vs-input
                v-validate="'max:256|alpha_spaces|required'"
                data-vv-validate-on="blur"
                name="last name"
                label-placeholder="LAST NAME"
                v-model="last_name"
                class="w-full mt-8"
                icon-pack="feather"
                icon="icon-user"
                icon-no-border
                size="large" />
                <span class="text-danger text-sm float-left">{{ errors.first('last name') }}</span>
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
               <vx-input-group>
                <template slot="prepend">
                    <div class="prepend-text bg-primary w-full mt-8">
                    <span>+60</span>
                    </div>
                </template>

                <vs-input
                v-validate="'min:9|max:10|numeric|required'"
                data-vv-validate-on="blur"
                name="phone number"
                label-placeholder="PHONE NUMBER"
                v-model="phone_number"
                class="w-full mt-8"
                size="large"/>
            </vx-input-group>
            <span class="text-danger text-sm float-left">{{ errors.first('phone number') }}</span>
            </div>
          </div>
          
          <div class="input-div">
            <div>
            <span class="label-placeholder">GENDER</span>
              <ul class="vx-row mt-6 center">
                <li class="vx-col w-1/2">
                <vs-radio class="center" color="#000080" v-model="gender" vs-value="Male">Male</vs-radio>
                </li>
                <li class="vx-col w-1/2">
                <vs-radio class="center" color="#F9278E" v-model="gender" vs-value="Female">Female</vs-radio>
                </li>
              </ul>
            </div>
          </div>

           <div class="input-div mb-10">
            <div>
                <span class="label-placeholder">DATE OF BIRTH</span>
                <flat-pickr v-model="dob" :config="{ dateFormat: 'Y-m-d' }" class="w-full" />
                <span class="text-danger text-sm float-left">{{ errors.first('dob') }}</span>
            </div>
           </div>

          <vs-button class="shadow-md w-full mt-2" @click="registerUser(first_name,last_name,phone_number,gender,dob)" :disabled="!validateForm">Continue</vs-button>
    
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'
import Navbar from '@/views/components/quicksend-navbar/Navbar.vue'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  data () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      gender: '',
      dob: ''
    }
  },
  components: {
    Logo,
    Navbar,
    flatPickr
  },
  computed: {
    ...mapGetters('user', ['user']),
    validateForm () {
      return !this.errors.any() && this.first_name !== '' && this.last_name !== '' && this.phone_number !== '' && this.gender !=='' && this.dob !==''
    },
    email: {
      get() {
        return this.user.email
      }
    },
    isInvited(){
      if(!localStorage.getItem('token')){
        return false
      }else{
        return true
      }
    }
  },
  methods: {
    registerUser(first_name,last_name,phone_number,gender,dob) {
      const userDetails = {
        first_name,
        last_name,
        phone_number: '+60' + phone_number,
        gender,
        dob
      }

      localStorage['user_details'] = JSON.stringify(userDetails);

      if (!this.validateForm)  return;
      if(this.isInvited) { Object.assign(userDetails, {isInvited:true}) }
      this.$store.dispatch('user/updateDetails', userDetails)
        .then((res) => {
          if(!userDetails.hasOwnProperty("isInvited")){
            this.$vs.notify({
            title: 'Yay!',
            text: 'Now you can now built your own organization',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            time:2500
            });
            this.$store.commit('user/UPDATE_USER_INFO', { onboard_step: 3 });
            this.$router.push({path: '/signup/orgdetails'});
          }else{
            this.$vs.notify({
            title: 'Yay!',
            text: 'Now you can now assist the business right away!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            time:2500
            });
            localStorage.removeItem('token')
            this.$store.commit('user/UPDATE_USER_INFO', { onboard_step: 6 });
            this.$router.push({path: '/dashboard'});
          }
        }).catch((error) => {
          console.log(error);
        });
    }
  }
}
</script>

<style>
* {
    margin: 0;
    box-sizing: border-box;
}

body {
  display:grid;
  height:100%;
  width:100%;
}

vs-input[v-model="email"]  {
    font-size: 1.75rem !important;
}

.vdp-datepicker input{
  height: 50px;
  text-align: center;
}

.container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-template-areas: "image form";
    grid-gap: 10rem;
    padding: 0 2rem;
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-area: image;
}

.img img{
   width: 500px; 
}

.signup-container {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
    grid-area: form;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
}


.input-div > div {
    position: relative;
    height: 45px;

}


/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

.label-placeholder {
    padding: 1rem !important;
    padding-left: .5rem !important;
    font-size: 0.7rem !important;
    font-weight: 400;
    color:rgba(0,0,0,.4);
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 5rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    .img img{
        width: 400px;
    }
}

vs-input[label-placeholder]{
    text-transform:capitalize;
} 

vs-input[label-placeholder]:focus{
    float: left;
} 

@media screen and (max-width: 900px) {
    .container{
        display: inherit;
        overflow-x:hidden;
    }
    .img{
        display: none;
    }
    .signup-container{
        justify-content: center;
    }
}
</style>
